import { render, staticRenderFns } from "./LabelObjectSetForm.vue?vue&type=template&id=63be14cb&"
import script from "./LabelObjectSetForm.vue?vue&type=script&lang=js&"
export * from "./LabelObjectSetForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports